import React from "react";
import { Button, Title } from "@skyportal/ui-kit";
import { useTranslation } from "react-i18next";
import ContractDropdown from "containers/ContractDropdown";
import config from "config";

import styles from "./styles.module.css";
import ModuleBreadcrumbs from "containers/ModuleBreadcrumbs";

export interface PageHeaderProps {
  title: React.ReactNode;
  withNavigationLinks?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, withNavigationLinks = false }) => {
  const { t } = useTranslation("esignDashboardPage");

  return (
    <header className={styles.root}>
      <div className={styles.titleBlock}>
        <ModuleBreadcrumbs />
        <Title level={2}>{title}</Title>
      </div>
      <div className={styles.subtitleBlock}>
        <ContractDropdown className={styles.contractDropdown} />
        {withNavigationLinks && (
          <div>
            <a href={config.eSignScriveLink} target="_blank" rel="noreferrer">
              <Button type="secondary" rightIcon="arrow-right" disabled={!config.eSignScriveLink}>
                {t("scriveLinkText")}
              </Button>
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
